import React, { useEffect, useState } from 'react';
import css from './SectionStocks.css';
import Benefits from './Benefits';
import StockItem from './StockItem';
import { useRequest } from '../../../../hooks/useRequest';
import { getFlipAndWinMonthPrizes } from '../../../../util/api';
import { Alert, IconSpinner } from '../../../../components';
import { getUserCountry } from '../../../../util/location';

export default ({ isMobile, computing }) => {
    const [cards, setCards] = useState([]);

    const { error, loading, request } = useRequest();

    const userCountry = getUserCountry();

    const requestCards = async () =>
        await request(
            () => getFlipAndWinMonthPrizes(userCountry),
            data => (Array.isArray(data) ? setCards(data) : null)
        );

    useEffect(() => {
        requestCards();
    }, []);

    if (loading) {
        return <IconSpinner />;
    }

    if (error) {
        return <Alert showAsPlainText type="failure" description={error} closeAllowed={false} />;
    }

    const monthPrizes = cards
        .filter(card => card.monthPrize)
        .map(card => ({
            ...card,
            id: card._id,
            description: card.dialogText1,
            inStock: (card.inStock || 0) - (card.totalWins || 0),
            total: card.inStock,
        }));

    const showPrizesBlock = monthPrizes.length > 0;

    return (
        <section className={css.root}>
            {!computing && <Benefits isMobile={isMobile} />}
            {showPrizesBlock && (
                <div>
                    <h2 className={css.heading}>Gewinne des Monats</h2>
                    <div className={css.stocksContainer}>
                        {monthPrizes.map(({ id, ...stockItem }) => (
                            <StockItem key={id} isMobile={isMobile} {...stockItem} />
                        ))}
                    </div>
                </div>
            )}
        </section>
    );
};
